import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export function ApiService(config: { baseName?: string }) {
  return (ctor: Function) => {
    ctor.prototype.baseName = config.baseName;
  };
}

@Injectable({ providedIn: 'root' })
export abstract class BaseApiService {
  protected baseName: string;

  protected getBaseUrl(): string {
    return `${this.getApiUrl()}api`;
  }

  protected getApiUrl(): string {
    return `${environment.apiUrl}`;
  }

  protected getUrl(id?: number | string): string {
    let url = `${this.getBaseUrl()}/${this.getBaseName()}/`;

    if (id) {
      url = url + `${id}/`;
    }

    return url;
  }

  private getBaseName() {
    if (this.baseName) {
      return this.baseName;
    }

    throw new TypeError(
      'Manager requires a base name, make sure your manger uses the ManagerImpl decorator',
    );
  }
}
